// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../node_modules/rescript/lib/es6/array.js";
import * as React from "react";
import * as NativeCarouselCmp from "../../../../common/components/carousel/components/NativeCarouselCmp.bs.js";
import * as TrackLiveTripConfig from "../../domain/store/TrackLiveTripConfig.bs.js";
import * as TrackLiveTripMarketingTitleCmp from "./TrackLiveTripMarketingTitleCmp.bs.js";
import * as TrackLiveTripMarketingVMMapper from "../view-model/TrackLiveTripMarketingVMMapper.bs.js";
import * as TrackLiveTripVehicleSwiperSlideCmp from "./TrackLiveTripVehicleSwiperSlideCmp.bs.js";

function TrackLiveTripMarketingVehiclesCmp(Props) {
  var available_vehicles = Props.available_vehicles;
  var selected_vehicle = Props.selected_vehicle;
  var vehicle_selector = Props.vehicle_selector;
  var total_slides = TrackLiveTripMarketingVMMapper.splitArray($$Array.of_list(available_vehicles), 6);
  return React.createElement("div", {
              className: "track-live-trip-marketing__vehicle-container"
            }, React.createElement(TrackLiveTripMarketingTitleCmp.make, {
                  title: TrackLiveTripConfig.marketing_vehicle_title
                }), React.createElement("div", {
                  className: "track-live-trip-swiper-container track-live-trip-swiper-container-newview"
                }, React.createElement(NativeCarouselCmp.make, {
                      children: $$Array.of_list(List.mapi((function (_key, slide) {
                                  return React.createElement("div", undefined, React.createElement(TrackLiveTripVehicleSwiperSlideCmp.make, {
                                                  vehicles_slide: slide,
                                                  selected_vehicle: selected_vehicle,
                                                  vehicle_selector: vehicle_selector
                                                }));
                                }), total_slides)),
                      delay: 1500,
                      autoplay: false,
                      is_mobile: true
                    })));
}

var make = TrackLiveTripMarketingVehiclesCmp;

export {
  make ,
  
}
/* react Not a pure module */
